import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";

interface NewFolderInputProps {
  value: string;
  onChange: (v: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
  depth: number;
  isCreating?: boolean;
}

export function NewFolderInput({ value, onChange, onSubmit, onCancel, depth, isCreating }: NewFolderInputProps) {
  return (
    <div className="flex items-center gap-1.5 py-1 pr-1 rounded-md bg-muted/30" style={{ paddingLeft: `${depth * 16 + 8}px` }}>
      <Input
        autoFocus
        placeholder="Folder name…"
        className="h-5 text-xs flex-1 border-0 bg-transparent shadow-none focus-visible:ring-0 px-0"
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyDown={e => {
          if (e.key === "Enter") onSubmit();
          if (e.key === "Escape") onCancel();
        }}
      />
      <Button size="sm" variant="ghost" className="h-5 text-[10px] px-1.5" onClick={onSubmit} disabled={!value.trim() || isCreating}>
        {isCreating ? <Loader2 className="h-3 w-3 animate-spin" /> : "Save"}
      </Button>
    </div>
  );
}
